<template>
	<div class = "mt3">
		<!-- ADD -->
		<div v-on:keyup.enter = "addSubmit" v-if = "adding">
			<div>
				<button class="btn"  @click = "cancel" >Cancel</button>
				<button class="btn"  @click = "addSubmit" >Submit</button>
			</div>
			<table>
				<tbody>
					<tr>
						<th>Date</th>
						<td>
							<input  type = "date" placeholder = "Date" v-model.trim = " addForm['Date']" v-bind:min = "currentDate">{{ errorMsg['Date']}}
						</td>
					</tr>
					<tr>
						<th>Note</th>
						<td>
							<input  type = "text" placeholder = "Note" v-model.trim = " addForm['Note']">{{ errorMsg['Note']}}
						</td>
					</tr>
					<tr>
						<th>Sessions</th>
						<td>
							<table>
								<thead>
									<tr>
										<th>Start</th>
										<th>End</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr >
										<td>
											<button class="btn"  @click = "addElement('Sessions')">Add</button>
										</td>
									</tr>
									<tr v-for = "(element, elementIndex) in addForm['Sessions'] ">
										<td>
											<input  type = "time" placeholder = "" v-model.trim = " addForm['Sessions'][elementIndex]['Start']">{{ errorMsg['Sessions'][elementIndex]['Start']}}
										</td>
										<td>
											<input  type = "time" placeholder = "" v-model.trim = " addForm['Sessions'][elementIndex]['End']">{{ errorMsg['Sessions'][elementIndex]['End']}}
										</td>
										<td >
											<button class="btn"  @click = "addForm['Sessions'].splice(elementIndex, 1); errorMsg['Sessions'].splice(elementIndex, 1)">Delete</button>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</tbody>
			</table>
		</div>


		<!-- EDIT -->
		<div v-on:keyup.enter = "editSubmit" v-else-if = "editing">
			<div>
				<button class="btn"  @click = "cancel" >Cancel</button>
				<button class="btn"  @click = "editSubmit" >Update</button>
			</div>
			<table>
				<tbody>
					<tr>
						<th>Date</th>
						<td>
							<input readonly type = "date" placeholder = "Date" v-model.trim = " editForm['Date']">{{ errorMsg['Date']}}
						</td>
					</tr>
					<tr>
						<th>Note</th>
						<td>
							<input  type = "text" placeholder = "Note" v-model.trim = " editForm['Note']">{{ errorMsg['Note']}}
						</td>
					</tr>
					<tr>
						<th>Sessions</th>
						<td>
							<table>
								<thead>
									<tr>
										<th>Start</th>
										<th>End</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr >
										<td>
											<button class="btn"  @click = "addElement('Sessions')">Add</button>
										</td>
									</tr>
									<tr v-for = "(element, elementIndex) in editForm['Sessions'] ">
										<td>
											<input  type = "time" placeholder = "" v-model.trim = " editForm['Sessions'][elementIndex]['Start']">{{ errorMsg['Sessions'][elementIndex]['Start']}}
										</td>
										<td>
											<input  type = "time" placeholder = "" v-model.trim = " editForm['Sessions'][elementIndex]['End']">{{ errorMsg['Sessions'][elementIndex]['End']}}
										</td>
										<td >
											<button class="btn"  @click = "editForm['Sessions'].splice(elementIndex, 1); errorMsg['Sessions'].splice(elementIndex, 1)">Delete</button>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</tbody>
			</table>
		</div>


		<!-- VIEW -->
		<div v-else>
			<h2>Special Schedules</h2>
			<div class="mt2 mb4">
				<button class="btn"  @click = "addStart" >Add</button>
				<button class="btn" @click = "addHolidays">Import</button>
			</div>
			<table class="table" v-for = "(y, yearIndex) in items">
				<thead>
					<tr>
						<th>Month</th>
						<th>Date</th>
						<th>Sessions</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody v-for = "(m, monthIndex) in y.Schedule" v-if = "showMonth(y['.key'], monthIndex, m)">
					<tr>
						<td >{{displayMonth(monthIndex)}} {{y[".key"]}}</td>
						<td colspan = "3"></td>
					</tr>
					<tr v-for = "(d, dayIndex) in m" v-if = "showDate(y['.key'], monthIndex, dayIndex)">
						<td></td>
						<td>{{dayIndex}} ({{d.Note}})</td>
						<td>
							<p v-for = "t in d.Sessions.split(',')">
								{{showTime(t)}}
							</p>
						</td>
						<td>
							<button class="btn" @click = "deleteItem(y['.key'], monthIndex, dayIndex)">Delete</button>
							<button class="btn" @click = "editStart(d, y['.key'], monthIndex, dayIndex)">Edit</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
var md5 = require('md5');
var uuid = require('uuid/v5');
var dbPath = "";
var docID = "";
var itemTemplate;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"Date","checkFun":"date","children":[],"defaultValue":"","inputType":"date","manyView":true,"max":"","min":"","placeholder":"2019-10-10","singleView":true,"type":"Date"},{"Name":"Note","checkFun":"none","children":[],"defaultValue":"","inputType":"textarea","manyView":true,"max":"","min":"","placeholder":"Note","singleView":true,"type":"Description"},{"Name":"Sessions","checkFun":"multi-time","children":[{"Name":"Start","checkFun":"time","defaultValue":"08:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"},{"Name":"End","checkFun":"time","defaultValue":"20:00","inputType":"time","manyView":false,"max":"11:59","min":"00:00","placeholder":"10:08","singleView":false,"type":"Time"}],"defaultValue":"","inputType":"time","manyView":true,"max":"","min":"","placeholder":"Array","singleView":true,"type":"MultiTime"}];
		return{
			// FORM
			addForm: {},
			editForm: {},
			viewForm: {},
			errorMsg: {},

			// NAV VARIABLES
			adding: false,
			editing: false,
			viewing: false,
			sorting: false,
			filterText: "",

			// PLACEHOLDER
			items: [],
			oriItem: {},
			indices: [],
			editIndex: "",

			excelError: "",
			currentDate: myDate.displayCurrentDate({sequcen: "y-m-d"})
		}
	},

	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/settings/preOrderSetting/allSchedule";
		return {
			items: myFB.db.collection(dbPath).orderBy("Date").where("Date", ">=", myDate.getTime()),
		}
	},
	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		addHolidays(){
			var yearNow = 2020;
			const MyHolidays = require('my-holidays');
			const holiday    = new MyHolidays(yearNow);
			const result     = holiday.list();

			// var state = this.$parent.$parent.$parent.storeSetting.Address.State;

			var allHolidays = [];
			var mode = {
				sequence: "d-m-y",
				monthMode: 1,
			};
			result.forEach(r=>{
				if (r.includes.includes("National")){
					allHolidays.push({
						date: myDate.displayDate(new Date(r.date).getTime(), mode),
						name: r.name,
						type: "National Holiday"
					})
				}
				// else if (r.includes.includes(state)){
				// 	allHolidays.push({
				// 		date: myDate.displayDate(new Date(r.date).getTime(), mode),
				// 		name: r.name,
				// 		type: "State Holiday"
				// 	})
				// }
			})

			var yearID = yearNow.toString();
			var itemExists = false;
			this.items.forEach(r=>{
				if (r[".key"] == yearID){
					itemExists = true;
				}
			})

			var monthID, dateID;
			if (itemExists){
				var update = {};
				allHolidays.forEach(r=>{
					monthID = parseInt(r.date.substring(3,5)).toString();
					dateID = parseInt(r.date.substring(0,2)).toString();
					update["Schedule." + monthID + "." + dateID] = {
						Sessions: "",
						Note: r.name
					};
				})
				myFB.updateDoc(dbPath, update, yearID, this, "Importing holidays...", "Holidays imported!");
			}
			else{
				var doc = {
					Date: new Date((parseInt(yearID) + 1).toString() + "-01-01 00:00").getTime(),
					ID: yearID,
					Schedule: {}
				};
				allHolidays.forEach(r=>{
					monthID = parseInt(r.date.substring(3,5)).toString();
					dateID = parseInt(r.date.substring(0,2)).toString();
					if (doc.Schedule[monthID] == undefined){
						doc.Schedule[monthID] = {};
					}
					doc.Schedule[monthID][dateID] = {
						Sessions: "",
						Note: r.name
					}
				})
				myFB.setDoc(dbPath, doc, yearID, this, "Importing holidays...", "Holidays imported!");
			}
		},
		displayMonth(input){
			var allMonths = ["January","February","March","April","May","June","July","August","September","October","November","December"];

			return allMonths[parseInt(input) - 1];
		},
		showDate(year, month, date){
			var dNow = new Date();
			dNow.setHours(0);
			dNow.setMinutes(0);
			dNow.setSeconds(-1);
			dNow = dNow.getTime();
			var dInput = new Date(year + "-" + month + "-" + date).getTime();
			return dNow <= dInput;
		},
		showMonth(year, month, days){
			var dNow = new Date();
			dNow.setHours(0);
			dNow.setMinutes(0);
			dNow.setSeconds(-1);
			dNow = dNow.getTime();
			var allDays = [];
			var day;
			for (var item in days){
				day = item;
			}
			var dInput = new Date(year + "-" + month + "-" + day).getTime();
			return dNow <= dInput;
		},
		showYear(item){
			var nDays = 0;
			for(var month in item.Schedule){
				for (var date in item.Schedule[month]){
					nDays++;
				}
			}
			return nDays > 0;
		},
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDate(input, mode);
		},
		formatDateTime(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDateTime(input, mode, {sequence: "hh:mm"});
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		showTime(t){
			if (!t){
				return "Closed";
			}
			var output = "";
			var d = new Date();
			d.setHours(t.substring(0,2));
			d.setMinutes(t.substring(3,5));

			output = myDate.displayTime(d.getTime(),{
				sequence: "hh:mm",
				hourFormat: 12
			});

			d.setHours(t.substring(6,8));
			d.setMinutes(t.substring(9,11));

			output += " - " + myDate.displayTime(d.getTime(),{
				sequence: "hh:mm",
				hourFormat: 12
			});

			return output;
		},
		//-------------------------------- FILTERS --------------------------------//
		filterItem(item, text){
			var filter = text.toUpperCase();
			var date = (item["Date"]).toString().toUpperCase().includes(filter);
			var note = (item["Note"]).toString().toUpperCase().includes(filter);
			var sessions = (item["Sessions"]).toString().toUpperCase().includes(filter);
			return date || note || sessions;
		},
		//-------------------------------- CREATE -------------------------------//
		addStart(){
			var response = myInput.init(itemTemplate);
			this.errorMsg = response.errorMsg;
			this.addForm = response.output;
			this.adding = true;
		},
		addSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, addForm = myCopier.copy(this.addForm);
			response = myInput.checkMain(addForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				var yearID = addForm.Date.substring(0,4);
				var monthID = parseInt(addForm.Date.substring(5,7)).toString();
				var dateID = parseInt(addForm.Date.substring(8,10)).toString();
				var itemExists = false;
				
				delete response.output.Date;
				var update = {};

				this.items.forEach(r=>{
					if (r[".key"] == yearID){
						itemExists = true;
					}
				})

				if (itemExists){
					update["Schedule." + monthID + "." + dateID] = response.output;
					myFB.updateDoc(dbPath, update, yearID, this, "Creating Special Schedule...", "SpecialSchedule created!");
				}
				else{
					var monthDate = new Date((parseInt(yearID) + 1).toString() + "-01-01 00:00");
					update.Date = monthDate.getTime();
					update["Schedule"] = {};
					update.Schedule[monthID] = {};
					update.Schedule[monthID][dateID] = response.output;
					myFB.setDoc(dbPath, update, yearID, this, "Creating Special Schedule...", "Special Schedule created!");
				}
				this.cancel();
			}
		},
		//------------------------------ UPDATE ------------------------------//
		editStart(item, year, month, date){
			item.Date = new Date(year + "-" + month + "-" + date).getTime();
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			console.log(editForm)
			var response = myInput.editMain(editForm, itemTemplate);
			this.errorMsg = response.errorMsg;
			this.editForm = response.output;
			this.editing = true;
		},
		editSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				var yearID = editForm.Date.substring(0,4);
				var monthID = parseInt(editForm.Date.substring(5,7)).toString();
				var dateID = parseInt(editForm.Date.substring(8,10)).toString();

				delete response.output.Date;
				var update = {};
				update["Schedule." + monthID + "." + dateID] = response.output;
				myFB.updateDoc(dbPath, update, yearID, this, "Updating Special Schedule...", "Special Schedule updated!");
				this.cancel();
			}
		},
		//----------------------------- BACK -----------------------------//
		cancel(){
			this.viewing = false;
			this.adding = false;
			this.editing = false;
			this.sorting = false;
		},
		addElement(elementName, elementIndex){
			var temp;
			itemTemplate.forEach(r=>{
				if (r.Name == elementName){
					temp = r.children;
				}
			})
			var newElement = myInput.init(temp);
			if (this.adding){
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.addForm[elementName].push(newElement.output);
			}
			else{
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.editForm[elementName].push(newElement.output);
			}
		},
		//----------------------------- RD -----------------------------//
		viewStart(item){
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.viewForm = response.output;
			this.viewing = true;
		},
		deleteItem(year, month, date){
			if (confirm("Confirm deleting?")){
				var update = {};

				var thisDoc = {};
				var num = 0;

				this.items.forEach(r=>{
					if (r[".key"] == year){
						for (var day in r.Schedule[month]){
							num++;
						}
					}
				})

				if (num > 1){
					update["Schedule." + month + "." + date] = myFB.fieldVal.delete();
				}
				else{
					update["Schedule." + month] = myFB.fieldVal.delete();
				}

				myFB.updateDoc(dbPath, update, year, this, "Deleting " + date + "...", "" + date+ " Deleted!");
			}
		},
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Manager/SpecialSchedule.vue